// PointHistory.js - 수정 완료 (변경 없음, 이미 완벽함)
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPointHistory, getPointBalance } from '../services/orderService';
import './PointHistory.css';

const PointHistory = () => {
  const navigate = useNavigate();
  const [points, setPoints] = useState([]);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [pointData, balanceData] = await Promise.all([
        getPointHistory(),
        getPointBalance()
      ]);
      setPoints(pointData.results || []);
      setBalance(balanceData.balance || 0);
    } catch (error) {
      console.error('포인트 조회 실패:', error);
    } finally {
      setLoading(false);
    }
  };

  const getPointIcon = (type) => {
    switch (type) {
      case 'earn':
        return { icon: '📈', color: 'point-earn' };
      case 'use':
        return { icon: '📉', color: 'point-use' };
      case 'cancel':
        return { icon: '🔄', color: 'point-cancel' };
      default:
        return { icon: '🎁', color: 'point-default' };
    }
  };

  return (
    <div className="point-history-container">
      {/* 헤더 */}
      <div className="point-header">
        <button onClick={() => navigate(-1)} className="back-btn">
          ‹
        </button>
        <h1>포인트</h1>
      </div>

      {/* 포인트 잔액 */}
      <div className="point-balance-card">
        <div className="balance-header">
          <span>보유 포인트</span>
          <span className="balance-icon">🎁</span>
        </div>
        <p className="balance-amount">{balance.toLocaleString()}P</p>
        <p className="balance-info">10,000P 이상부터 1만원 단위로 사용 가능</p>
      </div>

      {/* 포인트 내역 */}
      <div className="point-list">
        <h2 className="list-title">포인트 내역</h2>

        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
          </div>
        ) : points.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">🎁</div>
            <p>포인트 내역이 없습니다</p>
          </div>
        ) : (
          <div className="point-items">
            {points.map((point) => {
              const { icon, color } = getPointIcon(point.point_type);
              const isEarn = point.point_type === 'earn';

              return (
                <div key={point.id} className="point-item">
                  <div className="point-item-left">
                    <div className={`point-icon ${color}`}>
                      {icon}
                    </div>
                    <div className="point-details">
                      <p className="point-description">{point.description}</p>
                      <p className="point-date">
                        {new Date(point.created_at).toLocaleString('ko-KR')}
                      </p>
                      {point.order && (
                        <p className="point-order">
                          주문번호: {point.order}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="point-item-right">
                    <p className={`point-amount ${isEarn ? 'earn' : 'use'}`}>
                      {isEarn ? '+' : '-'}{Math.abs(point.amount).toLocaleString()}P
                    </p>
                    <p className="point-balance-after">
                      잔액: {point.balance.toLocaleString()}P
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default PointHistory;